<div class="py-px-25 px-px-12 gap flex-column">
  <app-text-separator text="En COURS"></app-text-separator>
  <div *ngFor="let item of randomData">
    <div
      *ngIf="item.status === StatusEnum.PENDING"
      class="my-px-24 border border-neutral-light-grey rounded-2 d-flex flex-column p-px-16"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <svg-icon src="assets/icons/building-black.svg"></svg-icon>
          <div class="fs-11 fw-7 text-neutral-dark">{{ item.location }}</div>
        </div>
        <div
          class="border text-accent fs-13 fw-7 border-neutral-light-grey bg-neutral-cloud rounded-chip"
        >
          {{ StatusEnum.PENDING }}
        </div>
      </div>
      <div class="d-flex flex-column">
        <div class="text-neutral-dark fs-16 fw-4">{{ item.missionName }}</div>
        <div class="text-neutral-dark-grey fs-13 fw-4">
          {{ item.date }}
        </div>
      </div>
    </div>
  </div>

  <app-text-separator text="DETAILS"></app-text-separator>
  <div *ngFor="let item of randomData">
    <div
      *ngIf="item.status === StatusEnum.VALIDATED"
      class="my-px-24 border border-neutral-light-grey rounded-2 d-flex flex-column p-px-16"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <svg-icon src="assets/icons/building-black.svg"></svg-icon>
          <div class="fs-11 fw-7 text-neutral-dark">{{ item.location }}</div>
        </div>
        <div
          class="border text-accent-green fs-13 fw-7 surface-success rounded-chip"
        >
          {{ StatusEnum.VALIDATED }}
        </div>
      </div>
      <div class="d-flex flex-column">
        <div class="text-neutral-dark fs-16 fw-4">{{ item.missionName }}</div>
        <div class="text-neutral-dark-grey fs-13 fw-4">
          {{ item.date }}
        </div>
      </div>
    </div>
  </div>
</div>
